import { Input, Label } from '@planuze/ui';
import { usePlansContent } from '../../../content/sections/plans.js';
import type { PlanForm } from '../../../hooks/use-plan-form.js';
import { CurrencyInput } from '../currency-input.js';

/* Assentos do plano de org (Model B, ADR-0653): a base inclui N assentos e cada excedente custa
   `extraSeatPriceCents`. O call-site só renderiza este grupo quando `form.isOrgPlan`. */
export function SeatFields({ form }: { readonly form: PlanForm }) {
  const copy = usePlansContent();
  return (
    <div className="grid grid-cols-2 gap-3 rounded-md border border-border p-3">
      <div className="space-y-1.5">
        <Label htmlFor="pf-included-seats">{copy.formFields.seatsIncluded}</Label>
        <Input
          id="pf-included-seats"
          type="number"
          min={0}
          value={String(form.includedSeats)}
          onChange={(e) => form.setIncludedSeats(Number.parseInt(e.target.value, 10) || 0)}
        />
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="pf-extra-seat-price">{copy.formFields.extraSeatPrice}</Label>
        <CurrencyInput
          id="pf-extra-seat-price"
          value={form.extraSeatPriceCents}
          currency="USD"
          onChange={form.setExtraSeatPriceCents}
        />
        <p className="text-sm text-muted-foreground">{copy.formFields.extraSeatHint}</p>
      </div>
    </div>
  );
}
